import { motion } from "framer-motion";
import { LoadingButton } from "../LoadingButton";

function FeaturesHero() {
  return (
    <section className="py-20 px-4 text-center relative">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          className="mb-6 inline-block"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-[#fff5eb] px-4 py-2 rounded-full border border-[#ff8c42]/20">
            <span className="text-[#ff8c42] font-medium">AI-Powered Email Management</span>
          </div>
        </motion.div>
        
        <motion.h1 
          className="text-4xl md:text-6xl font-bold mb-6 text-[#694e42]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          All the Features You Need to <br />
          <span className="bg-gradient-to-r from-[#946e5d] to-[#ff8c42] bg-clip-text text-transparent">
            Master Your Inbox
          </span>
        </motion.h1>
        
        <motion.p 
          className="text-xl text-[#8a7266] mb-12 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Discover how MailMaid's intelligent features can transform your email experience, save you hours every week, and help you focus on what really matters.
        </motion.p>
        
        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <LoadingButton 
            className="px-8 py-3 bg-[#ff8c42] text-white rounded-md font-medium shadow-md hover:bg-[#ff7a29]"
            loadingText="Connecting..."
          >
            Try All Features Free
          </LoadingButton>
          
          <motion.button
            className="px-8 py-3 border border-[#694e42] text-[#694e42] rounded-md font-medium"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Schedule a Demo
          </motion.button>
        </motion.div>
      </div>
      
      {/* Stats indicators */}
      <div className="max-w-5xl mx-auto mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { number: "20+", label: "Intelligent features" },
          { number: "5+", label: "Hours saved weekly" },
          { number: "100K+", label: "Satisfied users" }
        ].map((stat, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-xl p-6 shadow-md border border-[#e2dad3]"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 + index * 0.1 }}
            whileHover={{ y: -5, boxShadow: "0 15px 30px rgba(0,0,0,0.1)" }}
          >
            <div className="text-3xl font-bold text-[#ff8c42] mb-2">{stat.number}</div>
            <div className="text-[#694e42]">{stat.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default FeaturesHero;